module.exports = "<div ng-if=\"$ctrl.characteristicOptions\" \n     class=\"gridCharacteristicStyle\" \n     ui-grid-edit \n     ui-grid-row-edit\n     ui-grid-selection\n     ui-grid=\"$ctrl.characteristicOptions\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/characteristic-dashboard/characteristic-dashboard.html
// module id = 92
// module chunks = 0